import * as React from 'react'
import { AlertTriangle } from 'lucide-react'
import { cn } from '@/lib/utils'

const alertVariants = {
  default: 'border-border bg-background text-foreground',
  destructive: 'border-destructive/30 bg-destructive/10 text-foreground',
} as const

type AlertVariant = keyof typeof alertVariants

const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & { variant?: AlertVariant }
>(({ className, variant = 'default', ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn('rounded-xl border px-4 py-3', alertVariants[variant], className)}
    {...props}
  />
))
Alert.displayName = 'Alert'

const AlertTitle = React.forwardRef<HTMLHeadingElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => <h5 ref={ref} className={cn('mb-1 font-semibold leading-none tracking-tight', className)} {...props} />,
)
AlertTitle.displayName = 'AlertTitle'

const AlertDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => <p ref={ref} className={cn('text-sm leading-6 text-muted-foreground', className)} {...props} />,
)
AlertDescription.displayName = 'AlertDescription'

const AlertIcon = ({ className }: { className?: string }) => (
  <AlertTriangle className={cn('h-4 w-4 text-destructive', className)} aria-hidden="true" />
)

export { Alert, AlertTitle, AlertDescription, AlertIcon }
